import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Icon } from "@iconify/vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    iconName: {},
    hasBorders: { type: Boolean, default: true },
    color: {},
    size: { default: "md" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'button',
      { 'button-no-borders': !__props.hasBorders },
      __props.color ? `button--${__props.color}` : '',
      `button--${__props.size}`,
    ])
  }, [
    _createVNode(_unref(Icon), {
      icon: __props.iconName,
      class: "icon"
    }, null, 8, ["icon"])
  ], 2))
}
}

})